import Image from "../common/Image";
import { TOURISM_WEBSITE_URL } from "../../config/apiConfig";
import { footerConfig } from "../../config/homePageUtils";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const { contactInfo, quickLinks, policies, socialLinks, govtLogo } =
  footerConfig;

const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();

  const scrollToSection = (id) => {
    if (!id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  function obfuscateEmail(email) {
    return email.replace(/@/g, " [at] ").replace(/\./g, " [dot] ");
  }

  return (
    <footer className="footer">
      <div className="container mx-auto py-12">
        <div className="grid gap-5 grid-cols-5 grid-rows-1 max-[640px]:grid-cols-1 max-[1024px]:grid-cols-2  max-[1280px]:grid-cols-4 grid-cols-[2fr,1fr,1.5fr,1.5fr]">
          {/* Get in Touch */}
          <div>
            <h2 className="mb-6 font-bold">
              {language ? "संपर्क करें" : "Get in Touch"}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium ul-address">
              {contactInfo.map((item, i) => (
                <li key={i} className="flex items-start mb-9">
                  <Image src={item.icon} alt="icon" className="me-3 w-6 h-6" />
                  <span className="text-white text-sm">
                    {language ? item.label.hi : item.label.en}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="mb-6 font-bold">
              {language ? "मुख्य लिंक" : "Quick Links"}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              {quickLinks.map((link, i) => (
                <li key={i} className="mb-4">
                  <a
                    className="cursor-pointer"
                    onClick={() => {
                      if (location.pathname !== "/") {
                        navigate("/", { state: { scrollTo: link.href } });
                      } else {
                        scrollToSection(link.href);
                      }
                    }}
                  >
                    {language ? link.label.hi : link.label.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h2 className="mb-6 font-bold">
              {language ? "नीतियाँ" : "Policies"}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              {policies.map((policy, i) => (
                <li key={i} className="mb-4">
                  <a
                    onClick={() => {
                      navigate(policy.href);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="cursor-pointer"
                  >
                    {language ? policy.label.hi : policy.label.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter / Social */}
          <div>
            <h2 className="mb-6 font-bold">
              {language ? "समाचार पत्रिका" : "Newsletter"}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              <li>
                <div className="flex justify-between social-links">
                  {socialLinks.map((social, i) => (
                    <a
                      key={i}
                      onClick={(e) => {
                        if (!social.href) {
                          e.preventDefault(); // block navigation if url missing
                        } else {
                          window.open(social.href, "_blank");
                        }
                      }}
                      className="transition rounded-full flex justify-center items-center cursor-pointer"
                    >
                      <Image src={social.icon} alt={social.alt} />
                    </a>
                  ))}
                </div>
              </li>

              <li className="mt-5">
                <div className="flex justify-between">
                  <Image
                    src={govtLogo}
                    alt="Government Logos"
                    className="max-w-full"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

        <div className="sm:flex sm:items-center justify-center mt-4">
          <span className="text-sm text-white text-center copyright">
            © {year}{" "}
            <a
              onClick={() =>
                window.open(
                  TOURISM_WEBSITE_URL,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              className="cursor-pointer"
            >
              {language ? "उत्तराखंड पर्यटन" : "Uttarakhand Tourism"}
            </a>{" "}
            {language ? "| सभी अधिकार सुरक्षित" : "| All Rights Reserved"}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
